import ResumeSkillListItem from './ResumeSkillListItem'

export default ResumeSkillListItem
